import React from 'react';

import PropTypes from 'prop-types';

import WishlistToggleButton from '~/shared/components/WishlistToggleButton';
import { useSession } from '~/techstyle-shared/redux-core';

const ProductCardFavoriteButton = ({ product }) => {
  const { isLoggedIn } = useSession();
  if (!isLoggedIn) {
    return null;
  }

  // TODO: make cleaner wishlist toggle button
  return (
    <div className="absolute top-0 right-0 z-1 p-2">
      <WishlistToggleButton
        data-cnstrc-btn="add-to-favorites"
        product={product}
      />
    </div>
  );
};

ProductCardFavoriteButton.propTypes = {
  product: PropTypes.object,
};

export default ProductCardFavoriteButton;
